import { AssetsExplorerModel, DisplayNames } from 'Roblox';
import { concatTexts } from 'core-utilities';
import assetsExplorerModule from '../assetsExplorerModule.js';

function assetsService(assetsConstants, httpService, $log, thumbnailConstants) {
  'ngInject';

  function getNameForDisplay(item) {
    const currentItem = item;
    const { userTypes, robloxSystemUserId } = assetsConstants;
    const { Name: creatorName, Type: creatorType, Id: creatorTargetId } = item;

    if (
      userTypes.user === creatorType &&
      robloxSystemUserId !== creatorTargetId &&
      DisplayNames.Enabled()
    ) {
      // some of the inventory api is already include @ as creatorName
      // the better solution is to isoalte inventory api from www site
      // so not use same CreatorModal as item details page
      currentItem.nameForDisplay = creatorName.startsWith('@')
        ? creatorName
        : concatTexts.concat(['', creatorName]);
    } else {
      currentItem.nameForDisplay = creatorName;
    }
  }

  function getOwnerNameForDisplayInVIP(privateServer) {
    const currentPrivateService = privateServer;
    const { OwnerName } = privateServer;
    currentPrivateService.nameForDisplay = DisplayNames.Enabled()
      ? concatTexts.concat(['', OwnerName])
      : OwnerName;
  }

  return {
    currentPage: 0,
    itemsPerPage: 30,
    userId: AssetsExplorerModel.userId,
    assetTypeId: 0,

    getItemSection(category) {
      // library
      switch (category.categoryType) {
        case assetsConstants.types.decal:
        case assetsConstants.types.model:
        case assetsConstants.types.audio:
        case assetsConstants.types.video:
        case assetsConstants.types.plugin:
        case assetsConstants.types.meshPart:
          return assetsConstants.library;
      }

      // no section
      switch (category.categoryType) {
        case assetsConstants.types.place:
        case assetsConstants.types.badge:
        case assetsConstants.types.gamePass:
        case assetsConstants.types.animation:
        case assetsConstants.types.privateServers:
          return null;
      }

      // catalog
      return assetsConstants.catalog;
    },

    setCategory(category) {
      this.currentCategory = category;
      const subcategory = category.items[0];
      this.setSubcategory(subcategory);
      return true;
    },

    setSubcategory(subcategory) {
      if (subcategory !== null && typeof subcategory !== 'undefined') {
        this.currentSubcategory = subcategory;
        this.assetTypeId = this.currentSubcategory.id;
      }
      return true;
    },

    setPage(value) {
      if (value < 0) {
        $log.debug(`Invalid attempt to set page to page ${value}`);
        return false;
      }

      this.currentPage = value;
      return true;
    },

    translateWwwItem(item) {
      let itemId = item.Item.AssetId;
      let itemType = assetsConstants.itemTypes.asset;
      let thumbnailType = thumbnailConstants.thumbnailTypes.assetThumbnail;

      if (item.Item.AssetType === assetsConstants.assetTypeIds.badge) {
        itemType = assetsConstants.itemTypes.badge;
        thumbnailType = thumbnailConstants.thumbnailTypes.badgeIcon;
      } else if (item.Item.AssetType === assetsConstants.assetTypeIds.gamePass) {
        itemType = assetsConstants.itemTypes.gamePass;
        thumbnailType = thumbnailConstants.thumbnailTypes.gamePassIcon;
      } else if (
        item.Item.AssetType === assetsConstants.assetTypeIds.place &&
        item.Item.UniverseId
      ) {
        itemId = item.Item.UniverseId;
        itemType = assetsConstants.itemTypes.game;
        thumbnailType = thumbnailConstants.thumbnailTypes.gameIcon;
      }

      item.itemV2 = {
        id: itemId,
        type: itemType,
        thumbnail: {
          type: thumbnailType
        }
      };

      if (item.Creator) {
        getNameForDisplay(item.Creator);
      }

      if (item.PrivateServer) {
        getOwnerNameForDisplayInVIP(item.PrivateServer);
      }
    },

    getCatalogMetadata() {
      const params = {};
      return httpService.httpGet(assetsConstants.endpoints.getCatalogMetadata, params);
    },

    /* Used for asset to catalog mappings */

    getAssetToCategoryMappings() {
      const params = {};
      return httpService.httpGet(assetsConstants.endpoints.getAssetToCatalogCategory, params);
    },

    getAssetToSubcategoryMappings() {
      const params = {};
      return httpService.httpGet(assetsConstants.endpoints.getAssetToCatalogSubcategory, params);
    }

    /* Used for asset to catalog mappings */
  };
}

assetsExplorerModule.factory('assetsService', assetsService);
export default assetsService;
